import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ChooseButton, PickedLibrary, ConfirmButton } from '../interaction.service';

export enum ConfirmStatus {
    CANCELED,
    CONFIRMED,
    PLAN,
    WORKOUT,
    EXERCISE
}

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})

export class ConfirmComponent implements AfterViewInit {
    constructor(
        public bsModalRef: BsModalRef,
        private elementRef: ElementRef<HTMLElement>
    ) { }

    public title: string;
    public subtitle?: string;
    public message?: string;
    public modalWidth = '440px';
    public multiple: boolean;
    public buttonlist: ChooseButton[];
    public buttons?: ConfirmButton[]; // New: custom buttons with styling
    public cancelBtnName = 'Cancel';
    public confirmBtnName = 'Confirm';
    public confirmButtonStyle: 'default' | 'danger' | 'primary' | 'secondary' = 'default';
    public renderAsHtml: boolean;
    public hideCancel: boolean;

    public status: ConfirmStatus;

    public confirm() {
        this.status = ConfirmStatus.CONFIRMED;
        this.onClose(this.status);
        this.bsModalRef.hide();
    }

    public onButtonClick(button: ConfirmButton) {
        if (button.value === 'cancel' || button.value === 'CANCELED' || button.value === ConfirmStatus.CANCELED) {
            this.status = ConfirmStatus.CANCELED;
        } else if (button.value === 'confirm' || button.value === 'CONFIRMED' || button.value === ConfirmStatus.CONFIRMED) {
            this.status = ConfirmStatus.CONFIRMED;
        } else {
            this.status = button.value !== undefined ? (button.value as ConfirmStatus) : ConfirmStatus.CONFIRMED;
        }
        this.onClose(this.status);
        this.bsModalRef.hide();
    }

    public pickedOption(option){
        this.status = option;
        this.onPick(option);
        this.bsModalRef.hide();
    }

    public cancel() {
        this.status = ConfirmStatus.CANCELED;
        this.onClose(this.status);
        this.bsModalRef.hide();
    }

    public getButtonClass(button: ConfirmButton): string {
        const baseClass = 'btn';
        const styleClass = button.style || 'default';
        
        if (styleClass === 'danger') {
            return `${baseClass} btn-danger`;
        } else if (styleClass === 'primary') {
            return `${baseClass} btn-primary`;
        } else if (styleClass === 'secondary') {
            return `${baseClass} btn-secondary`;
        }
        return `${baseClass} btn-default`;
    }

    public getConfirmButtonClass(): string {
        const baseClass = 'btn';
        if (this.confirmButtonStyle === 'danger') {
            return `${baseClass} btn-danger`;
        } else if (this.confirmButtonStyle === 'primary') {
            return `${baseClass} btn-primary`;
        } else if (this.confirmButtonStyle === 'secondary') {
            return `${baseClass} btn-secondary`;
        }
        return `${baseClass} btn-default`;
    }

    ngAfterViewInit(): void {
        const dialog = this.elementRef.nativeElement.closest('.modal-dialog') as HTMLElement | null;
        const content = dialog?.querySelector('.modal-content') as HTMLElement | null;

        if (dialog && this.modalWidth) {
            const width = `min(${this.modalWidth}, calc(100vw - 24px))`;
            dialog.style.width = width;
            dialog.style.maxWidth = width;
        }

        if (content) {
            content.style.borderRadius = '12px';
            content.style.maxHeight = '86vh';
            content.style.overflow = 'hidden';
            content.style.display = 'flex';
            content.style.flexDirection = 'column';
        }
    }

    private onPick(status: PickedLibrary) { }
    private onClose(status: ConfirmStatus) { }
}
